/*jshint esversion: 11 */

// Widgets de modais que antes viviam em <script> inline nas views. O Livewire 3 insere o HTML do
// modal via template.innerHTML e nunca executa <script> (mesmo problema do window.phoneInput, ver
// libs/intl-tel-input.js); aqui ficam globais chamadas por x-init nas views.

// share-ownership: o componente dispara 'copy-to-clipboard'. Registrado uma vez, no carregamento
// do bundle (antes era re-registrado, com guarda, a cada abertura do modal).
if (!window.__copyToClipboardListenerAdded) {
    window.__copyToClipboardListenerAdded = true;

    window.addEventListener('copy-to-clipboard', (event) => {
        window.Util.copyToClipboard(event.detail.text);
    });
}

// producer/event/occupied-seats: pan/zoom no mapa. `root` é o elemento do modal; o mapa é
// procurado dentro do timeout porque o SVG do mapa ainda está sendo montado no x-init.
window.occupiedSeatsPanzoom = function (root) {
    setTimeout(() => {
        const elem = root.querySelector('#mapbgzoom');
        const parent = elem?.parentElement;

        if (!elem || !parent) {
            return;
        }

        let startScale = 1;
        let startY = 0;

        if (elem.offsetHeight > parent.offsetHeight) {
            startScale = parent.offsetHeight / elem.offsetHeight;
            startY = 0 - ((elem.offsetHeight - parent.offsetHeight) / 2);
        }

        const panzoom = window.Panzoom(elem, {
            maxScale: 5,
            minScale: startScale,
            startScale: startScale,
            startY: startY,
            animate: true,
            excludeClass: 'seat selectionable-sector',
        });

        parent.addEventListener('wheel', panzoom.zoomWithWheel);
    }, 200);
};

// admin/payments/view-order: mapa Leaflet com o círculo de precisão da localização do pedido.
window.orderLocationMap = function (el, lat, lng) {
    const casasDecimais = (numero) => {
        const partes = numero.toString().split('.');
        return partes[1] ? partes[1].length : 0;
    };

    // Raio em metros pela menor precisão (casas decimais) entre latitude e longitude.
    const raio = Math.round(111320 / Math.pow(10, Math.min(casasDecimais(lat), casasDecimais(lng))));

    const map = window.L.map(el).setView([lat, lng], 15);

    window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    window.L.circle([lat, lng], {
        radius: raio,
        color: '#ff0000',
        weight: 3,
        fillColor: '#ff0000',
        fillOpacity: 0.25,
    }).addTo(map).bindPopup(`Raio: ${raio} metros`);
};

// producer/leads/import: FilePond do upload da planilha. `wrapper` é o div com wire:ignore que
// contém o input; `componentId` é o id do componente Livewire dono do upload.
window.leadsImportFilePond = function (wrapper, componentId) {
    const resetEventName = 'filepond-reset-excelFile';

    const detectFileType = (source, fallbackType) => {
        const filename = String(source?.name || '').toLowerCase();

        if (filename.endsWith('.csv')) {
            return 'text/csv';
        }

        if (filename.endsWith('.xlsx')) {
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        }

        if (filename.endsWith('.ods')) {
            return 'application/vnd.oasis.opendocument.spreadsheet';
        }

        return fallbackType;
    };

    const bootFilePond = () => {
        const input = wrapper.querySelector('input[type="file"]');

        if (!input || input.dataset.filepondBooted === 'true') {
            return;
        }

        if (typeof window.FilePond === 'undefined') {
            requestAnimationFrame(bootFilePond);
            return;
        }

        input.dataset.filepondBooted = 'true';

        const livewireComponent = window.Livewire?.find(componentId) || null;
        const pond = window.LivewireFilePond.create(input);

        pond.setOptions({
            allowPaste: false,
            allowMultiple: false,
            allowFileTypeValidation: true,
            acceptedFileTypes: [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.oasis.opendocument.spreadsheet',
                'text/csv',
                '.xlsx',
                '.csv',
                '.ods',
            ],
            fileValidateTypeDetectType: (source, type) => Promise.resolve(detectFileType(source, type)),
            labelFileTypeNotAllowed: 'Formato não suportado',
            fileValidateTypeLabelExpectedTypes: 'Aceitos: .xlsx, .csv ou .ods',
            allowFileSizeValidation: true,
            maxFileSize: '200MB',
            server: {
                process: (fieldName, file, metadata, load, error, progress) => {
                    if (!livewireComponent) {
                        error('Componente Livewire não encontrado.');
                        return;
                    }

                    livewireComponent.upload('excelFile', file, load, error, progress);
                },
                revert: (filename, load) => {
                    if (!livewireComponent) {
                        load();
                        return;
                    }

                    livewireComponent
                        .call('removeUpload', 'excelFile', filename)
                        .then(load);
                },
            },
        });

        livewireComponent?.on(resetEventName, () => {
            pond.removeFiles();
        });
    };

    requestAnimationFrame(bootFilePond);
};
